var $tabButtons = Array.prototype.slice.call(document.querySelectorAll('.js-title'), 0);
var $tabContent = Array.prototype.slice.call(document.querySelectorAll('.product-description__tab-content'), 0);

if ($tabButtons.length > 0) {

  $tabButtons.forEach(function ($el) {
    $el.addEventListener('click', function () {

      $tabContent.forEach(function (e) {
        e.classList.remove("product-description--active");
      });

      $tabButtons.forEach(function ($el) {
        $el.classList.remove("product-description--active");
      });

      var target = $el.dataset.target;
      var $target = document.getElementById(target);

      $el.classList.toggle('product-description--active');
      $target.classList.toggle('product-description--active');

    });
  });
}